export * from "./alternates";
export * from "./metadata";
export * from "./sitemap";
import * as metadata from "./metadata";

export { metadata };
